var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"auto","height":"auto","viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"5.5","cy":"5.5","r":"5","fill":"#2371E4","stroke":"white"}})])}
var staticRenderFns = []

export { render, staticRenderFns }